// assets/blog.js
// FHL GO — Blog page behaviour (i18n + toggle + reveal)

(function () {
  console.log("[blog.js] loaded");

  const I18N = {
    en: {
      toggleLabel: "EN | ES",

      // Header / crumbs
      crumbHome: "Home",
      crumbBlog: "Blog",

      // Hero
      blogLabel: "Blog",
      blogTitle: "FHL GO Blog",
      blogSub:
        "News, tips, and stories about shipping from the U.S. to Peru, Venezuela, and Costa Rica.",
      blogCtaServices: "Explore services",
      blogCtaComing: "See what’s coming",

      // Chips
      blogChipTips: "Shipping tips",
      blogChipGuides: "Country guides",
      blogChipStories: "Customer stories",
      blogChipUpdates: "FHL GO updates",

      // Latest section
      blogLatestTitle: "Latest from FHL GO",
      blogLatestSub:
        "We’re setting up this space to bring you practical shipping guides, country-specific tips, and behind-the-scenes updates.",
      blogStatus: "Coming soon",
      blogLatestBody:
        "No posts yet—but they’re on the way. Once articles go live, you’ll find the most recent ones here.",
      blogLatestCta: "Learn how our service works",

      // Coming soon header
      blogComingTitle: "Article previews",
      blogComingSub:
        "Here’s the kind of content we’re planning to publish. Once ready, these will turn into full blog posts.",

      // Tags
      blogTagHowTo: "HOW-TO",
      blogTagGuide: "GUIDE",
      blogTagInsights: "INSIGHTS",
      blogTagStory: "STORY",

      // Teaser cards
      blogTease1Title: "Shipping from the U.S. to Peru: what to know",
      blogTease1Note:
        "Coming soon: step-by-step tips to avoid surprises with size, weight, and customs.",
      blogTease2Title: "Sending packages to Costa Rica: simple packing tips",
      blogTease2Note:
        "Coming soon: how to pack smarter and avoid damaged items on the way to Costa Rica.",
      blogTease3Title: "What affects delivery times to Venezuela?",
      blogTease3Note:
        "Coming soon: a clear explanation of routes, seasons, and checkpoints that impact timelines.",
      blogTease4Title:
        "How families use FHL GO to send essentials home",
      blogTease4Note:
        "Coming soon: real stories of shipments that made a difference back home.",

      // Footer labels (shared)
      followTitle: "FOLLOW US ON",
      companyTitle: "COMPANY",
      legalTitle: "LEGAL INFO",
      lnkAbout: "About Us",
      lnkServices: "Services",
      lnkBlog: "Blog",
      lnkTerms: "Terms of Service",
      lnkPrivacy: "Privacy Policy",
      lnkRefunds: "Refund Policy",
      copyright:
        "© 2025 FHL GO. Powered by Shopify — Developed by DIGIFUZEFX",
    },

    es: {
      toggleLabel: "ES | EN",

      crumbHome: "Inicio",
      crumbBlog: "Blog",

      blogLabel: "Blog",
      blogTitle: "Blog de FHL GO",
      blogSub:
        "Noticias, consejos e historias sobre envíos desde EE. UU. a Perú, Venezuela y Costa Rica.",
      blogCtaServices: "Ver servicios",
      blogCtaComing: "Ver lo que viene",

      blogChipTips: "Consejos de envío",
      blogChipGuides: "Guías por país",
      blogChipStories: "Historias de clientes",
      blogChipUpdates: "Novedades FHL GO",

      blogLatestTitle: "Lo último de FHL GO",
      blogLatestSub:
        "Estamos preparando este espacio para compartir guías prácticas, consejos por país y novedades detrás de escena.",
      blogStatus: "Próximamente",
      blogLatestBody:
        "Todavía no hay publicaciones, pero ya vienen. Cuando estén listas, verás aquí las más recientes.",
      blogLatestCta: "Conoce cómo funciona nuestro servicio",

      blogComingTitle: "Avances de artículos",
      blogComingSub:
        "Este es el tipo de contenido que planeamos publicar. Cuando estén listos, se convertirán en artículos completos.",

      blogTagHowTo: "PASO A PASO",
      blogTagGuide: "GUÍA",
      blogTagInsights: "INSIGHTS",
      blogTagStory: "HISTORIA",

      blogTease1Title:
        "Envíos desde EE. UU. a Perú: lo que debes saber",
      blogTease1Note:
        "Próximamente: consejos paso a paso para evitar sorpresas con tamaño, peso y aduanas.",
      blogTease2Title:
        "Cómo enviar paquetes a Costa Rica: trucos de empaques sencillos",
      blogTease2Note:
        "Próximamente: cómo empacar mejor y evitar daños en el camino hacia Costa Rica.",
      blogTease3Title:
        "¿Qué afecta los tiempos de entrega a Venezuela?",
      blogTease3Note:
        "Próximamente: una explicación clara de rutas, temporadas y controles que afectan los tiempos.",
      blogTease4Title:
        "Cómo las familias usan FHL GO para enviar lo esencial a casa",
      blogTease4Note:
        "Próximamente: historias reales de envíos que marcaron la diferencia.",

      followTitle: "SÍGUENOS",
      companyTitle: "COMPAÑÍA",
      legalTitle: "INFO LEGAL",
      lnkAbout: "Quiénes somos",
      lnkServices: "Servicios",
      lnkBlog: "Blog",
      lnkTerms: "Términos del servicio",
      lnkPrivacy: "Política de privacidad",
      lnkRefunds: "Política de reembolsos",
      copyright:
        "© 2025 FHL GO. Con tecnología de Shopify — Desarrollado por DIGIFUZEFX",
    },
  };

  function applyLang(lang) {
    const dict = I18N[lang] || I18N.en;
    console.log("[blog.js] applyLang:", lang);

    // Plain text
    document.querySelectorAll("[data-i18n]").forEach((el) => {
      const key = el.dataset.i18n;
      if (!key) return;
      if (dict[key]) el.textContent = dict[key];
    });

    // HTML-enabled if ever needed
    document.querySelectorAll("[data-i18n-html]").forEach((el) => {
      const key = el.dataset.i18nHtml;
      if (!key) return;
      if (dict[key]) el.innerHTML = dict[key];
    });

    // Update header toggle label
    const toggleEl =
      document.getElementById("lang") ||
      document.getElementById("langToggleTop");
    if (toggleEl && dict.toggleLabel) toggleEl.textContent = dict.toggleLabel;

    // Page <title>
    document.title = lang === "es" ? "FHL GO — Blog" : "FHL GO — Blog";

    // Persist shared language key
    try {
      localStorage.setItem("fhl_lang", lang);
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", function () {
    console.log("[blog.js] DOMContentLoaded");

    // Initial lang from storage
    const saved = (function () {
      try {
        return localStorage.getItem("fhl_lang") || "en";
      } catch (e) {
        return "en";
      }
    })();
    applyLang(saved);

    // Handle clicks on header toggle just for this page
    const toggleEl =
      document.getElementById("lang") ||
      document.getElementById("langToggleTop");

    if (toggleEl) {
      toggleEl.addEventListener("click", function () {
        let current = "en";
        try {
          current = localStorage.getItem("fhl_lang") || "en";
        } catch (e) {}

        const next = current === "en" ? "es" : "en";
        console.log("[blog.js] toggle click →", next);

        applyLang(next);

        // Broadcast so logo / other scripts can respond
        try {
          const ev = new CustomEvent("fhlgo:lang-switch", {
            detail: { lang: next },
          });
          document.dispatchEvent(ev);
        } catch (e) {}
      });
    }

    // Also react if some other script fires the event
    document.addEventListener("fhlgo:lang-switch", function (e) {
      const lang = (e && e.detail && e.detail.lang) || "en";
      console.log("[blog.js] fhlgo:lang-switch →", lang);
      applyLang(lang);
    });

    // Reveal-on-scroll (scoped, in case global.js doesn't catch it)
    if (
      !(
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      )
    ) {
      const io = new IntersectionObserver(
        (entries) => {
          for (const ent of entries) {
            if (ent.isIntersecting) {
              ent.target.classList.add("is-visible");
              io.unobserve(ent.target);
            }
          }
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );

      const nodes =
        document.querySelectorAll(".blog-page [data-reveal]") ||
        document.querySelectorAll("[data-reveal]");

      nodes.forEach((el) => io.observe(el));
    }
  });
})();
